export default __webpack_public_path__ + "static/media/icon.6a56a5c9.png";